import React from 'react';
import { TextField } from '@mui/material';
import { TOTP } from '../totp';

// Six-digit authenticator code input. `autoComplete="one-time-code"` lets
// password managers (1Password, iCloud Keychain) fill it in; non-digits are
// dropped so pasted "123 456" works.
const CodeField = ({ value, onChange, label = '6-digit code', autoFocus = false, id }) => (
  <TextField
    id={id}
    fullWidth
    label={label}
    value={value}
    onChange={(e) => onChange(e.target.value.replace(/\D/g, '').slice(0, TOTP.digits))}
    margin="normal"
    required
    autoFocus={autoFocus}
    autoComplete="one-time-code"
    slotProps={{
      htmlInput: {
        inputMode: 'numeric',
        pattern: `[0-9]{${TOTP.digits}}`,
        maxLength: TOTP.digits,
        'aria-label': label,
        style: { letterSpacing: '0.3em', fontFamily: 'monospace', fontSize: '1.25rem' },
      },
    }}
  />
);

export default CodeField;
